module.exports = __webpack_public_path__ + "img/export-walking-profile.ca13f6c0.svg";